import { REGIONAL_PROD_ENVS, REGIONAL_PROD_SUBDOMAINS } from 'constants/envs';

const mailroomUrl: Record<string, string> = {
  prod: 'https://mailroom.alta.avigilon.com',
  dev: 'https://mailroom.dev.alta.avigilon.com',
  sandbox: 'https://mailroom.sandbox.alta.avigilon.com',
  mine: 'http://localhost:3000/mailroom',
  test: 'https://mailroom.test.alta.avigilon.com',
};

REGIONAL_PROD_ENVS.forEach((env) => {
  mailroomUrl[env] =
    `https://mailroom.${REGIONAL_PROD_SUBDOMAINS[env]}.alta.avigilon.com`;
});

export const getMailroomUrl = (region: OP.Env): string => {
  return `${mailroomUrl[region]}`;
};
